/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ControlValueAccessor,
  FormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { REGEX } from "../../../config/app.config";
import { EInputStyleType } from "../../../data-types/input-style.enum";
import { iconsLibrary } from "../../../../theme/constants";
@Component({
  selector: "cowing-timepicker",
  templateUrl: "./cowing-timepicker.component.html",
  styleUrls: ["./cowing-timepicker.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CowingTimepickerComponent),
      multi: true,
    },
  ],
})
export class CowingTimepickerComponent implements ControlValueAccessor {
  @HostListener("document:click", ["$event"])
  onClick(event) {}

  @Input("disabled") disabled: boolean = false;
  @Input("value") value: any;

  @Input("inputStyle") inputStyle: string = EInputStyleType.Primary;
  @Input("label") label: string = "";
  @Input("placeholder") placeholder: string = "";
  @Input("required") required: boolean = false;
  @Input("validateInput") validateInput: boolean = true;
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;

  @Output("newValue") newValue = new EventEmitter();

  @ViewChild("input") input: ElementRef;
  keyboard: any;
  toggledShowPassword = false;
  valid = false;
  checked: boolean;
  msg = "";
  status = "";

  private internalInputChange;
  constructor() {}

  public onInputChange($event?: any) {
    if ($event) {
      this.value = $event.target.value;
      if (!this.isForm) {
        this.newValue.emit(this.value);
      }
    }
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.internalInputChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }

  onChangeKeyboard(input) {
    this.value = input;
    this.internalInputChange(this.value);
    // this.validateFormat();
    console.log("Input changed", input);
  }

  onKeyPress(button) {
    console.log("Button pressed", button);
  }
}
